var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38765 5.30757C3.63758 5.05763 4.04281 5.05763 4.29275 5.30757L7.68022 8.69504L11.0677 5.30757C11.3176 5.05763 11.7228 5.05763 11.9728 5.30757C12.2227 5.55751 12.2227 5.96273 11.9728 6.21267L8.13277 10.0527C7.88283 10.3026 7.4776 10.3026 7.22767 10.0527L3.38765 6.21267C3.13771 5.96273 3.13771 5.55751 3.38765 5.30757Z",
    fill: "#0A98EA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.1b85a02e08f0bf2068b14c0195537d0e.svg";
export { ForwardRef as ReactComponent };